import type { WorkModeType } from "@evidenceb/athena-common/interfaces/Workmode";
import { useContext } from "react";
import { configStore } from "../contexts/ConfigContext";
import { type WorkMode, WorkModeStatus } from "../interfaces/Config";

export const useLang = () => {
  const {
    config: { lang },
  } = useContext(configStore);
  return lang as string;
};

/**
 * @returns the workmode configuration, or undefined for legacy versions where
 * there is no workmode configuration
 */
export const useWorkmodeConfig = (
  workmodeType: WorkModeType,
): WorkMode | undefined => {
  const {
    config: { workModesConfig },
  } = useContext(configStore);
  if (!workModesConfig) {
    return undefined;
  }
  return (
    workModesConfig?.find((workmode) => workmode.type === workmodeType) ??
    inactiveWorkmode(workmodeType)
  );
};
const inactiveWorkmode = (type: WorkModeType): WorkMode => ({
  type,
  status: WorkModeStatus.Disabled,
});

export const useImages = () => {
  const {
    config: {
      features: { images },
    },
  } = useContext(configStore);
  return images;
};
